import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
	selector: 'app-moniepoint-failure-modal',
	templateUrl: './moniepoint-failure-modal.component.html',
	styleUrls: ['./moniepoint-failure-modal.component.scss']
})
export class MoniepointFailureModalComponent implements OnInit {
	@Output() closeModal = new EventEmitter();
	@Output() emitAction = new EventEmitter();
	@Input() description: string;
	@Input() buttonText: string;
	@Input() canShowCancelButton: boolean;
	@Input() hideErrorIcon: boolean = false;
	@Input() errorType: ErrorType;
	readonly MODAL_ERROR_TYPE: ErrorType = 'MODAL';
	readonly NON_MODAL_ERROR_TYPE: ErrorType = 'NON-MODAL';
	@Input() title: string;
	@Input() useFullButton: boolean;
	@Input() isTableUse: boolean;
	@Input() showSuspendedCountDown = false;
	@Input() suspensionReleaseTime: any;
	@Input() useFailureSecondaryButton: Boolean;
	@Input() secondaryButtonName = 'Action';

	constructor() {
	}

	ngOnInit(): void {
		if (!this.errorType) {
			this.errorType = this.MODAL_ERROR_TYPE;
		}
		if (!this.buttonText) {
			this.buttonText = 'Cancel';
		}
		this.useFullButton = !this.useFailureSecondaryButton;
		if (this.useFailureSecondaryButton) {
			this.useFullButton = false;
			this.canShowCancelButton = true;
			this.buttonText = this.secondaryButtonName;

		}
	}

	continue() {
		this.emitAction.emit();
	}

	cancelModal() {
		this.closeModal.emit(false);
	}

}

export type ErrorType = 'MODAL' | 'NON-MODAL';
